import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-Bjtexw5f.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as Text } from '../Text/Text-Cv6a53CC.js';

const focusMixin = /*#__PURE__*/css(["content:\"\";position:absolute;top:0;bottom:0;left:0;right:0;outline:", ";outline-offset:2px;z-index:1;pointer-events:none;", ""], ({
  theme
}) => `${theme.focusVisible.outlineWidth} ${theme.focusVisible.outlineStyle} ${theme.focusVisible.outlineColor}`, isMobile(css(["outline-offset:-2px;"])));
const tabUnderline = /*#__PURE__*/css(["position:absolute;content:'';height:3px;margin:0;bottom:0;left:0;right:0;background:", ";border-radius:2px 2px 0 0;"], ({
  theme
}) => theme.card.tabs.activeBorder);
const Wrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-0"
})(["position:relative;border-bottom:1px solid ", ";", ";"], ({
  theme
}) => theme.card.tabs.border, ({
  theme,
  isTabOverflow
}) => isTabOverflow && isMobile(css(["::after{position:absolute;height:calc(100% - 1px);width:", ";left:auto;inset-inline-start:auto;right:0;inset-inline-end:0;top:0;content:\" \";background:", ";}/*! @noflip */ [dir=\"rtl\"] &&::after{background:", ";right:auto;inset-inline-start:auto;left:0;inset-inline-end:0;}"], theme.navigation.tabs.mobile.width, theme.card.tabs.scrollableIndicatorBackground, theme.card.tabs.scrollableIndicatorBackgroundRTL)));
const TabGroupWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-1"
})(["display:block;background:", ";border-radius:", " ", " 0 0;", ""], ({
  theme
}) => theme.card.tabs.bg, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, isMobile(css(["overflow-x:scroll;::-webkit-scrollbar{display:none;}scrollbar-width:none;"])));

// Styled component representing the Tab Group.
const TabGroup = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-2"
})(["box-sizing:border-box;border-radius:", " ", " 0 0;display:flex;flex-wrap:wrap;align-items:stretch;margin-bottom:10px;list-style:none;background:", ";padding:0;margin:0;", ""], ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.tabs.bg, isMobile(css(["white-space:nowrap;flex-wrap:nowrap;"])));
TabGroup.displayName = 'TabGroup';
const DefaultText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-3"
})(["", " ", " ", " ::after{display:block;content:\"", "\";height:0;visibility:hidden;overflow:hidden;user-select:none;pointer-events:none;font-weight:bold;@media speech{display:none;}}"], ({
  theme
}) => theme.typography.h5, isMobile(css(["", ""], ({
  theme
}) => theme.typography.mobile.h5)), ({
  isActive
}) => !isActive && `
    font-weight: 500;
  `, ({
  $label
}) => $label || '');
DefaultText.displayName = 'DefaultText';
// Styled component representing the Tab.
const Tab = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-4"
})(["background:", ";display:inline-block;list-style-type:none;color:", ";margin:", ";text-align:left;text-align:start;outline:none;padding:0px;position:relative;border:none;:first-of-type{/*! @noflip */ border-radius:", " 0 0 0;margin-inline-start:16px;/*! @noflip */ [dir=\"rtl\"] &{/*! @noflip */ border-radius:0 ", " 0 0;}}:last-of-type{margin-inline-end:16px;}", " ", " ", ""], ({
  theme
}) => theme.card.tabs.bg, ({
  theme
}) => theme.card.tabs.fontColor, ({
  theme
}) => theme.card.tabs.margin, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, ({
  theme,
  isActive
}) => isActive && css(["color:", ";border-inline-start:none;border-inline-end:none;border-top:none;"], theme.card.tabs.activeFontColor), ({
  theme,
  isActive
}) => !isActive && css(["border:none;:hover{color:", ";cursor:pointer;background-color:", ";}"], theme.card.tabs.hoverFontColor, theme.card.tabs.hover), ({
  focusVisible
}) => focusVisible && css([":first-of-type::after{", " /*! @noflip */ border-radius:", " 0 0 0;/*! @noflip */ [dir=\"rtl\"] &{/*! @noflip */ border-radius:0 ", " 0 0;}}:not(:first-of-type)::after{", "}"], focusMixin, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, focusMixin));
Tab.displayName = 'Tab';

// Styled component for the space after the tabs with border bottom
const TabRemainSpace = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-5"
})(["width:100%;background:", ";flex:1;/*! @noflip */ border-radius:0 ", " 0 0;/*! @noflip */ [dir=\"rtl\"] &{/*! @noflip */ border-radius:", " 0 0 0;}", ""], ({
  theme
}) => theme.card.tabs.bg, ({
  theme
}) => theme.card.radius, ({
  theme
}) => theme.card.radius, isMobile(css(["padding-inline-end:", ";"], ({
  theme
}) => theme.navigation.tabs.mobile.width)));
const TabWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30054544__sc-yhkqwq-6"
})(["padding:13px 0;", " ", ""], ({
  $isActive
}) => $isActive && css(["::after{", "}"], tabUnderline), ({
  $isActive
}) => !$isActive && css([":hover::after{", "}"], tabUnderline));

export { DefaultText as D, TabGroupWrapper as T, Wrapper as W, TabGroup as a, TabRemainSpace as b, Tab as c, TabWrapper as d };
//# sourceMappingURL=TabbedCard.styles-MBoivQYr.js.map
